// /ptDates DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정.

import type { GridColDef } from "@mui/x-data-grid";
import { IPtDate } from "../interfaces";

// 집계(숫자성) 컬럼 공통 스펙
const countColumn = (field: string, headerName: string): GridColDef<IPtDate> => ({
  field,
  headerName,
  type: "number",
  width: 88,
  minWidth: 80,
  align: "right",
  headerAlign: "right",
});

export const ptDateColumns: GridColDef<IPtDate>[] = [
  {
    field: "id",
    headerName: "ID",
    type: "number",
    width: 84,
    minWidth: 72,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "presentationId",
    headerName: "해당 설명회 공지",
    type: "string",
    width: 132,
    minWidth: 110,
  },
  {
    field: "date",
    headerName: "날짜",
    type: "string",
    width: 116,
    minWidth: 108,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "time",
    headerName: "시간",
    type: "string",
    width: 96,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
  },
  countColumn("ablePersonNum", "허용인원"),
  countColumn("participantCnt", "신청인원"),
  countColumn("waitingCnt", "대기인원"),
  { ...countColumn("version", "버전"), width: 76, minWidth: 68 },
  {
    field: "updatedDate",
    headerName: "수정일",
    type: "string",
    width: 150,
    minWidth: 120,
    align: "center",
    headerAlign: "center",
  },
];
